var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21612SenseiLogosServicesEnrollment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 648 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:#231f20;}.cls-3{fill:#35afc8;}.cls-4{fill:#612466;}.cls-5{fill:#895b8c;}.cls-6{fill:#b091b2;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.32,
    y1: 51.6,
    x2: 55.47,
    y2: 47.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35afc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2d94a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#216d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#174b56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0f3037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#081b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#040c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#010303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 69.54,
    y1: 71.87,
    x2: 70.18,
    y2: 69.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78.68,
    y1: 84.32,
    x2: 79.16,
    y2: 82.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35afc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2d94a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#216d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#174b56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0f3037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#081b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#010303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.81,151.09c-24.07,0-39.85-14-39.84-34.92h13.24c0,14,10.81,22.73,26.61,22.74,17.9,0,26.63-7.51,26.63-19.24,0-8.73-3.9-14.75-26.91-18.67-23.16-4.08-36.4-11.31-36.39-29.21s14.31-29.47,36.42-29.46c22.87,0,37,12.36,37,32.52H247.62c0-12.18-8.26-20.31-23.9-20.32-16.1,0-23.62,7-23.63,16.83,0,9,4.81,13.54,26.16,17.47,22.87,4.37,37,10.85,37,30.85C263.23,140.13,247.12,151.1,223.81,151.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.22,125.29c-5.43,16.54-18.67,25.86-36.57,25.85-22.26,0-39.7-17.77-39.69-40.49,0-22.41,17.48-40.75,39-40.74,20,0,39.25,16.57,39.08,44.1l-65.13,0c1.64,16.1,14,25.58,26.76,25.59,11,0,18.8-5.26,23-14.28ZM332.9,102.57c-3.15-12.64-13.68-21.07-25-21.07-10.68,0-22,7.8-25.28,21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.23,151.38c-18.81,0-32.49-10.1-34.58-26.49h12.93c1.65,9,10.52,14.6,21.65,14.61,12,0,19.41-5.86,19.42-12.63,0-5.41-2.1-9.47-21-12S427.36,107.59,427.37,93c0-11.13,9.64-23,30.4-23,17.9,0,29.93,9,31.58,24.24H476.41c-1.8-8.27-9.17-12.49-18.64-12.49-10.23,0-17.61,4.8-17.61,10.81,0,5.57,4.36,7.53,19.55,9.94,17.14,2.72,31.28,6,31.27,23.64C491,141.62,477.73,151.39,459.23,151.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.91,125.42c-5.42,16.55-18.67,25.87-36.57,25.86-22.26,0-39.7-17.78-39.68-40.49,0-22.41,17.47-40.75,39-40.74,20,0,39.25,16.57,39.08,44.1l-65.13,0c1.64,16.09,14,25.58,26.76,25.58,11,0,18.81-5.25,23-14.27ZM559.59,102.7c-3.15-12.63-13.68-21.06-25-21.07-10.68,0-22,7.81-25.28,21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.26,149.51H580.47l0-77.47h12.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.26,62.84H580.47l0-11.27h12.79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M418.85,149.4H406.17V102.14c0-11.93-6.65-20.69-19-20.69-11.78,0-20.38,8.76-20.38,20.39V149.4H353.92V71.64H366.3v8.45A28.68,28.68,0,0,1,389,69.67c19,0,29.9,13.59,29.9,32.92Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.94,73.32V73c0-.2,0-.39,0-.58s0-.53,0-.8v-.07a14.39,14.39,0,0,1,.54-2.94v0c.07-.27.16-.54.25-.8s.11-.31.17-.46.08-.21.13-.32a14.86,14.86,0,0,1,10.26-8.9l.1,0c.29-.07.57-.14.86-.19l83.55-15.38A14.48,14.48,0,0,1,140,42.3a18.42,18.42,0,0,0-5.47-.83l-99-.06A18.31,18.31,0,0,0,19.62,68.86l46.15,80.05L42.05,78.52A15,15,0,0,1,40.94,73.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129,73.36c0-.09,0-.19,0-.29V72.5c0-.27,0-.54,0-.8v-.07a14.26,14.26,0,0,0-.53-2.94v0c-.08-.27-.17-.54-.26-.81s-.11-.3-.17-.45l-.12-.32a14.86,14.86,0,0,0-10.26-8.92l-.1,0c-.28-.07-.57-.14-.86-.19L33.11,42.48A15.17,15.17,0,0,0,30,42.22a18.74,18.74,0,0,1,5.47-.82l99,.06a18.31,18.31,0,0,1,15.84,27.47l-46.25,80,23.81-70.36A14.84,14.84,0,0,0,129,73.36Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.5,83.83a.81.81,0,0,1,0-.16v-.31c0-.14,0-.29,0-.43v0a7.59,7.59,0,0,1,.29-1.58h0c0-.15.09-.29.14-.43l.09-.25a1.22,1.22,0,0,1,.07-.17,8,8,0,0,1,5.53-4.8h0l.47-.11,45-8.28a8.05,8.05,0,0,1,1.68-.14,9.79,9.79,0,0,0-3-.45l-53.36,0A9.87,9.87,0,0,0,51,81.43l24.88,43.14L63.09,86.63A7.8,7.8,0,0,1,62.5,83.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110,83.85a.76.76,0,0,1,0-.15v-.31c0-.15,0-.29,0-.43v0a8.26,8.26,0,0,0-.28-1.59h0c0-.14-.09-.29-.14-.43a2.34,2.34,0,0,0-.09-.24l-.06-.18a8,8,0,0,0-5.53-4.8l-.06,0-.46-.1-45-8.34a8.05,8.05,0,0,0-1.68-.14,10.07,10.07,0,0,1,2.95-.44l53.36,0a9.87,9.87,0,0,1,8.54,14.81L96.52,124.58l12.83-37.92A7.91,7.91,0,0,0,110,83.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.13,90.06V90a.43.43,0,0,1,0-.16,1.55,1.55,0,0,1,0-.22v0a4.29,4.29,0,0,1,.14-.81h0a1.42,1.42,0,0,1,.07-.22s0-.08,0-.13a.59.59,0,0,0,0-.08,4.06,4.06,0,0,1,2.81-2.44h0l.23-.05,22.89-4.21a3.53,3.53,0,0,1,.85-.07,4.86,4.86,0,0,0-1.5-.23l-27.12,0a5,5,0,0,0-4.34,7.52l12.64,21.93-6.5-19.28A3.94,3.94,0,0,1,75.13,90.06Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.27,90.07V90a.86.86,0,0,0,0-.16,1.62,1.62,0,0,0,0-.22v0a4.32,4.32,0,0,0-.14-.8h0a1.87,1.87,0,0,0-.07-.22l0-.12a.36.36,0,0,0,0-.09,4,4,0,0,0-2.8-2.44h0l-.24-.05L73,81.61a3.53,3.53,0,0,0-.85-.07,4.86,4.86,0,0,1,1.5-.23l27.12,0a5,5,0,0,1,4.34,7.52L92.45,110.77,99,91.49A3.93,3.93,0,0,0,99.27,90.07Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.47,52.09l-52.3-9.67a16.47,16.47,0,0,0-3.18-.2,15.6,15.6,0,0,0-5,2.46L56.33,57.37Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.25,72.38,58.06,67.16a5.78,5.78,0,0,0-1.45-.09,9.5,9.5,0,0,0-2.83,1.41l16.83,6.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.25,84.25l-8.12-1.51L75,82l-2.1-.38a3,3,0,0,0-.74,0,4.63,4.63,0,0,0-1.47.72l8.59,3.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.17,215.9c-7,0-11.67-4.09-11.67-10.21h3.88c0,4.1,3.17,6.65,7.79,6.65,5.24,0,7.79-2.2,7.79-5.64,0-2.55-1.14-4.31-7.88-5.45s-10.65-3.31-10.65-8.55,4.18-8.62,10.65-8.62c6.69,0,10.83,3.61,10.83,9.51h-3.78c0-3.57-2.43-6-7-6s-6.92,2.07-6.92,4.93c0,2.64,1.41,4,7.67,5.11,6.69,1.28,10.82,3.17,10.82,9S213,215.9,206.17,215.9Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.46,208.33c-1.59,4.85-5.46,7.57-10.7,7.57a11.89,11.89,0,0,1-.22-23.77c5.85,0,11.49,4.85,11.44,12.9H224.92a8,8,0,0,0,7.84,7.49,7,7,0,0,0,6.73-4.19Zm-3.61-6.64a7.81,7.81,0,0,0-7.31-6.17,7.89,7.89,0,0,0-7.4,6.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.57,195.87c-3.92-.22-7.26,1.85-7.26,6.39v13.12h-3.75V192.7h3.61v2.56a8,8,0,0,1,7.4-3.08Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.66,215.38h-4l-8.23-22.68h4l6.3,18.05,6.25-18.05h4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.33,189.27h-3.74v-4.45h3.74Zm0,26.11h-3.74V192.7h3.74Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.49,215.9a11.61,11.61,0,0,1-11.36-11.84c0-6.56,5.11-11.93,11.36-11.93a10.85,10.85,0,0,1,10.57,7.57h-4a7.3,7.3,0,0,0-6.56-4.13c-4.18,0-7.62,3.83-7.62,8.49s3.44,8.41,7.62,8.41a7.19,7.19,0,0,0,6.56-4.14h4A10.81,10.81,0,0,1,305.49,215.9Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.2,208.33c-1.59,4.85-5.46,7.57-10.7,7.57a11.89,11.89,0,0,1-.22-23.77c5.85,0,11.49,4.85,11.44,12.9H322.66a8,8,0,0,0,7.84,7.49,7,7,0,0,0,6.73-4.19Zm-3.61-6.64a7.81,7.81,0,0,0-7.31-6.17,7.89,7.89,0,0,0-7.4,6.17Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.58,216c-5.5,0-9.51-2.95-10.12-7.75h3.78c.49,2.64,3.08,4.27,6.34,4.27,3.52,0,5.68-1.72,5.68-3.7,0-1.58-.62-2.77-6.16-3.52s-8.85-2.11-8.85-6.38c0-3.26,2.82-6.74,8.89-6.74,5.24,0,8.76,2.64,9.25,7.09H359.6c-.53-2.42-2.68-3.65-5.46-3.65-3,0-5.15,1.41-5.15,3.17s1.28,2.2,5.72,2.9c5,.79,9.16,1.76,9.16,6.91C363.87,213.09,360,216,354.58,216Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.63,184.82v3.57h-18.1v9.25h16.34v3.56H385.53v10.57h18.1v3.61H381.79V184.82Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M427.67,215.38H424V201.6c0-3.48-1.94-6-5.55-6a5.78,5.78,0,0,0-5.94,5.94v13.87h-3.74V192.7h3.61v2.47a8.36,8.36,0,0,1,6.6-3c5.55,0,8.72,4,8.72,9.6Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445,195.87c-3.91-.22-7.26,1.85-7.26,6.39v13.12H434V192.7h3.61v2.56a8,8,0,0,1,7.39-3.08Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.89,204.11a11.41,11.41,0,1,1-22.81,0c0-6.61,5-12,11.41-12S469.89,197.5,469.89,204.11Zm-3.75,0c0-4.71-3.43-8.54-7.65-8.54s-7.62,3.83-7.62,8.54,3.43,8.36,7.62,8.36S466.14,208.73,466.14,204.11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.52,215.38h-3.74V182.62h3.74Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M488.42,215.38h-3.74V182.62h3.74Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.08,215.38h-3.75V201.25c0-3.53-1.67-5.68-5.15-5.68-3.08,0-5.32,2.55-5.32,5.94v13.87h-3.7V201.25c0-3.53-1.76-5.68-5.11-5.68-3.08,0-5.37,2.55-5.37,5.94v13.87h-3.74V192.7h3.61v2.47a7.37,7.37,0,0,1,6-3,7.69,7.69,0,0,1,7,3.88,7.94,7.94,0,0,1,7.09-3.88c5.24,0,8.41,3.57,8.41,9.2Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554,208.33c-1.58,4.85-5.46,7.57-10.7,7.57a11.89,11.89,0,0,1-.21-23.77c5.85,0,11.48,4.85,11.44,12.9H535.49a8,8,0,0,0,7.83,7.49,7,7,0,0,0,6.74-4.19Zm-3.61-6.64a7.79,7.79,0,0,0-7.3-6.17,7.89,7.89,0,0,0-7.4,6.17Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M578.06,215.38h-3.7V201.6c0-3.48-1.93-6-5.54-6a5.78,5.78,0,0,0-6,5.94v13.87h-3.74V192.7h3.61v2.47a8.37,8.37,0,0,1,6.6-3c5.55,0,8.72,4,8.72,9.6Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M593.52,215.38c-5.29.61-8.94-2.51-8.94-8.28V196.27H581.5V192.7h3.08v-4.84h3.7v4.84h5.15v3.57h-5.15V207.1c0,4,2.46,5,5.24,4.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21612SenseiLogosServicesEnrollment);
export default __webpack_public_path__ + "static/media/21612 Sensei Logos_Services Enrollment.4b3c147719f15eebbb4049e58c4cf6b9.svg";
export { ForwardRef as ReactComponent };